export default __webpack_public_path__ + "static/media/1-colocada.ecb9d50b.png";